// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__BF0iq","approved":"Status_approved__2PH2H","rejected":"Status_rejected__2evDD","expired":"Status_expired__2Yu46","label":"Status_label__2b1l7"};